import React from 'react';

/**
 * Draft notice banner — sits at the top of Privacy and Terms.
 * Remove the rendering of this component (or delete the import) once
 * the final, lawyer-reviewed version of the document is published.
 */
export default function DraftBanner({ documentName }) {
  return (
    <div
      role="alert"
      style={{
        background: '#FFF8E5',
        borderBottom: '0.5px solid #E8D9A0',
        padding: '14px 0',
      }}
    >
      <div className="oc-shell">
        <div className="oc-row" style={{ gap: 14, alignItems: 'flex-start' }}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#8A6914"
            strokeWidth="1.6"
            style={{ flexShrink: 0, marginTop: 2 }}
          >
            <path d="M12 2 L1 22 h22 z" />
            <path d="M12 9 v5" />
            <circle cx="12" cy="18" r="0.8" fill="#8A6914" />
          </svg>
          <div style={{ fontSize: 13, lineHeight: 1.55, color: '#5A4709' }}>
            <strong style={{ fontWeight: 500 }}>Draft — pending legal review.</strong>{' '}
            This {documentName} is a working draft prepared as a starting point. It has
            not been reviewed by an attorney and should not be relied upon. The final
            version will replace this document before public launch.
          </div>
        </div>
      </div>
    </div>
  );
}
